
import * as api from "../constant/NewAPI";
import { DataTable } from "primereact/datatable";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Column } from "primereact/column";
import Select from "react-select";
import Utils from "../constant/Utils";
import { Button, Modal, ModalBody, ModalHeader, ModalTitle } from "react-bootstrap";

// import * as api from "../constant/API";

const DocumentRepository = () => {

    const roleId = localStorage.getItem('RoleId');
    const userId = localStorage.getItem('UserId');

    const [searchInput, setSearchInput] = useState('');
    const [documentList, setDocumentList] = useState([]);
    const [docName, setDocName] = useState('');
    const [uploadOption, setUploadOption] = useState('');
    const [uploadDoc, setUploadDoc] = useState('');
    const [openModal, setOpenModal] = useState(false);

    const optionList = [
        { value: "Public", label: "Public" },
        { value: "Private", label: "Private" }
    ]

    useEffect(() => {
        getDocumentList()
    }, [])

    function getDocumentList() {
        const doclst = api.DocumentList //"?role=" + roleId + "&userId=" + userId;
        fetch(doclst, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((docResponse) => docResponse.json())
            .then((docResult) => {
                if (docResult.error == true) {
                    if (docResult.code == 401) {
                        Utils.logoutUser();
                    }
                } else {
                    if (docResult.data != null) {
                        setDocumentList(docResult.data)
                    }
                }
            })
            .catch((error) => {
                console.log("Failed to fetch sports list", error);
            })
    }

    const filteredData = documentList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value.toString().toLowerCase()
        );
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    return (
        <>
            <div className="content container">
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row">
                                <div className="col-sm-12">
                                    <div className="court-tab-content">
                                        <div className="card card-tableset">
                                            <div className="card-body">
                                                <div className="coache-head-blk">
                                                    <div className="row align-items-center">
                                                        <div className="row col-lg-12">
                                                            <div className="row col-lg-12">
                                                                <div className="col-lg-4">
                                                                    <Link
                                                                        to="#"
                                                                        className="btn btn-secondary"
                                                                        onClick={() => setOpenModal(true)}
                                                                    >
                                                                        <i className="feather-plus" />&nbsp;
                                                                        Add Document
                                                                    </Link>
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-12"></div>
                                                            <div className="col-lg-6">
                                                            </div>
                                                            <div className="col-lg-6">
                                                                <div className="dataTables_filter">
                                                                    <label>
                                                                        <input
                                                                            type="text"
                                                                            value={searchInput}
                                                                            onChange={(e) => setSearchInput(e.target.value)}
                                                                            placeholder="Search"
                                                                            className="form-control"
                                                                        />
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="tab-content">
                                                        <div
                                                            className="tab-pane fade show active"
                                                            id="nav-Recent"
                                                            role="tabpanel"
                                                            aria-labelledby="nav-Recent-tab"
                                                            tabIndex={0}
                                                        >
                                                            <div className="table-responsive table-datatble">
                                                                <DataTable
                                                                    className="table datatable"
                                                                    value={filteredData}
                                                                    paginator
                                                                    rows={10}
                                                                    rowsPerPageOptions={[10, 25, 50]}
                                                                    currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                                                >
                                                                    <Column
                                                                        sortable
                                                                        headerClassName="text-uppercase"
                                                                        field="slNo"
                                                                        // body={slNoRender}
                                                                        header="Sl &nbsp; No"
                                                                    ></Column>
                                                                    <Column
                                                                        sortable
                                                                        headerClassName="text-uppercase"
                                                                        field="documentName"
                                                                        header="Document Name"
                                                                    // body={nameRender}
                                                                    ></Column>
                                                                    <Column
                                                                        sortable
                                                                        headerClassName="text-uppercase"
                                                                        field="DocumentPrivacy"
                                                                        header="Document Privacy"
                                                                    // body={groupRender}
                                                                    ></Column>
                                                                    <Column
                                                                        sortable
                                                                        headerClassName="text-uppercase"
                                                                        field="DocumentFileName"
                                                                        header="Document File Name"
                                                                        // body={typeRender}
                                                                        className="table-inset-btn"
                                                                    ></Column>
                                                                    <Column
                                                                        sortable
                                                                        headerClassName="text-uppercase"
                                                                        field="DocumentUploadDate"
                                                                        header="Document Upload Date"
                                                                        // body={typeRender}
                                                                        className="table-inset-btn"
                                                                    ></Column>

                                                                    <Column
                                                                        className="text-link view-detail-pink"
                                                                    // body={detailsRender}
                                                                    ></Column>
                                                                </DataTable>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Modal
                show={openModal}
                centered
                size="md"
                onHide={() => setOpenModal(false)}
            >
                <ModalHeader>
                    <ModalTitle>
                        <h4 className="mb-0 text-uppercase"><i className="fas fa-plus" />Add Document</h4>
                    </ModalTitle>
                    <Button
                        variant=""
                        className="btn-close"
                        onClick={() => setOpenModal(false)}
                    ></Button>
                </ModalHeader>
                <ModalBody>
                    <div className="col-lg-12 mb-10">
                        <label className="form-label">Document Name</label>
                        <input
                            type="text"
                            className="form-control"
                            style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                            id="docnm"
                            value={docName}
                            onChange={(e) => { setDocName(e.target.value); }}
                            placeholder="Document Name"
                        />
                    </div>
                    <div className="col-lg-12 mb-10">
                        <label className="form-label">Upload</label>
                        <Select
                            value={optionList.find(opt => opt.value === uploadOption) ? {
                                value: uploadOption,
                                label: optionList.find(opt => opt.value === uploadOption)?.label
                            } : null}
                            onChange={(e) => {
                                setUploadOption(e.value);
                            }}
                            options={optionList.map(opt => ({
                                value: opt.value,
                                label: opt.label
                            }))}>
                        </Select>
                    </div>
                    <div className="col-lg-12 mb-10">
                        <label className="form-label">Upload Document</label>
                        <input
                            type="file"
                            className="form-control"
                            style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                            id="docupload"
                            onChange={(e) => setUploadDoc(e.target.files[0])}
                            // accept=".jpg,.jpeg,.png"
                            placeholder="Document Name"
                        />
                    </div>
                </ModalBody>
            </Modal>
        </>
    );

};

export default DocumentRepository;